import Popup from '../popup'
import ShoppingcartPopupProduct from '../shoppingcart-popup-product'
import BlockFactory from '../../scripts/support/BlockFactory'

export default class ShoppingcartPopup extends Popup {
	static title = 'shoppingcart-popup'

	init() {
		super.init()

		this.shoppingcartContent = this.getElement('content')
		this.shoppingcartCount = this.getElement('product-count')
		this.shoppingcartTotal = this.getElement('total')
		this.shoppingcartTotalExcl = this.getElement('total-excl')

		this.closeButtons = this.element.querySelectorAll('[data-close]')
		this.closeButtons.forEach(closeButton => {
			closeButton.addEventListener('click', () => this.close())
		})

		this.eventEmitter.on('product:add', payload => {
			this.update(payload)
			this.toggle()
		})
		this.eventEmitter.on('overlay:close', () => this.hidePopup())
		this.eventEmitter.on('shoppingcart-popup-product:update', payload =>
			this.update(payload)
		)
		this.eventEmitter.on('shoppingcart-popup-button:toggle', () => this.toggle())

		this.bindProductEvents()
	}

	bindProductEvents() {
		this.element
			.querySelectorAll('.shoppingcart-popup-product')
			.forEach(element => {
				BlockFactory.create(ShoppingcartPopupProduct, element, false)
			})
	}

	toggle() {
		if (this.hasModifier('active')) {
			this.close()
			return
		}

		this.open()
	}

	hidePopup() {
		this.addModifier('hidden')
		this.removeModifier('active')
	}

	update(payload) {
		if (this.shoppingcartCount) {
			this.shoppingcartCount.textContent = payload.count
		}

		if (this.shoppingcartContent) {
			this.shoppingcartContent.innerHTML = payload.html
		}

		if (this.shoppingcartTotal) {
			this.shoppingcartTotal.textContent = payload.total.toFixed(2)
		}

		if (this.shoppingcartTotalExcl) {
			this.shoppingcartTotalExcl.textContent = payload.totalExcl.toFixed(2)
		}

		this.eventEmitter.emit('shoppingcart-popup:update', payload)
		this.bindProductEvents()
	}
}
